import { PatientHeaderBandSkeleton } from '@/components/patients/PatientHeaderBand/PatientHeaderBandSkeleton';
import { PatientLeftRailSkeleton } from '@/components/patients/PatientLeftRail/PatientLeftRailSkeleton';
import { Box, Skeleton } from '@mui/material';
import { useMatch } from 'react-router';

import { PatientDetailsFrame } from './PatientDetailsFrame';
import { calendarRailColumnSx } from './railLayout';

type PatientDetailsFrameSkeletonProps = {
    hasLayoutV2: boolean;
    calendarRail: boolean;
};

/* The patient details page before its code has loaded. Takes the flags as props so it renders
   without reading or waiting on anything, and imports only light pieces since it ships with the
   routes. The body stays empty until the section's own skeleton loads. */
export const PatientDetailsFrameSkeleton = ({
    hasLayoutV2,
    calendarRail,
}: PatientDetailsFrameSkeletonProps) => {
    const onScheduling = Boolean(useMatch('/patients/:patientId/scheduling')) || hasLayoutV2;

    return (
        <PatientDetailsFrame
            leftRail={!hasLayoutV2 && <PatientLeftRailSkeleton />}
            header={hasLayoutV2 && <PatientHeaderBandSkeleton />}
            rightRail={
                calendarRail && (
                    <Box sx={calendarRailColumnSx(onScheduling)}>
                        <Skeleton variant='rectangular' height='100%' />
                    </Box>
                )
            }
        >
            {null}
        </PatientDetailsFrame>
    );
};
